import React from 'react';
import { useMicrosite } from '../../../../contexts/franchise/microsite-context';

const FranchiseLicenses = (): JSX.Element => {
    const microsite = useMicrosite();

    const {
        biohazardContractorLicense,
        cslbContractorLicense,
        commercialContractorLicense,
        electricalContractorLicense,
        generalContractorLicense,
        moldRemediationContractorLicense,
        plumbingContractorLicense,
        residentialContractorLicense,
    } = microsite?.franchise?.licenses || {};

    const licenseTexts = {
        'Biohazard Cleanup': biohazardContractorLicense,
        'CSLB (California)': cslbContractorLicense,
        Commercial: commercialContractorLicense,
        'Electrical License': electricalContractorLicense,
        'General Contractor License': generalContractorLicense,
        'Mold Remediation': moldRemediationContractorLicense,
        Plumbing: plumbingContractorLicense,
        Residential: residentialContractorLicense,
    };

    return (
        <ul>
            {Object.entries(licenseTexts).map(([key, val]) => {
                if (val && typeof val !== 'boolean') {
                    return (
                        <li key={key}>
                            <strong>
                                {key}
                                :
                            </strong>
                            {' '}
                            {val}
                        </li>
                    );
                }
                if (val && typeof val === 'boolean') {
                    return (
                        <li key={key}><strong>{key}</strong></li>
                    );
                }
                return null;
            })}
        </ul>
    );
};

export default FranchiseLicenses;
